const profileUrl = "v1/credit/accounts/profile";
export {
  profileUrl
};
//# sourceMappingURL=endpoints.js.map
